/**
 * Permissões do console de rebalanceamento (Fase 8).
 *
 * Enquanto a 8A era só leitura, a rota vivia com `requiredPermission` nulo — o
 * plano registrava que a permissão entraria "quando a 8C introduzir escrita".
 * A 8C entrou: o console move luta de posição e de quadra ao vivo, reescreve as
 * arestas da árvore e copia o número novo para a súmula. Sem permissão, qualquer
 * usuário autenticado remontava a ordem de um evento em andamento.
 *
 * São dois níveis de propósito. A visão de Carga é a observabilidade da 8A e
 * serve a quem coordena sem mover nada (coordenador de quadra, árbitro chefe);
 * juntar tudo numa permissão só tiraria essa tela de quem já a usava.
 *
 * Vizinhança do módulo de eventos: 1830 pesagem, 1831 imprimir pesagem,
 * 1832 exportar inscritos, 1833 estender pesagem.
 */

/** Aplicar e desfazer movimento de luta. É a permissão de escrita. */
export const REBALANCEAMENTO_APLICAR = 1834;

/** Abrir o console em leitura (métricas, desvio, alertas, ocorrências). */
export const REBALANCEAMENTO_VER = 1835;

/**
 * Quem entra na rota: qualquer um dos dois.
 *
 * `ProtectedRoute` trata array como "qualquer uma delas", e quem pode aplicar
 * obviamente pode ver — não faz sentido exigir as duas.
 */
export const REBALANCEAMENTO_ACESSO = [REBALANCEAMENTO_APLICAR, REBALANCEAMENTO_VER];

/** Compara sem depender do tipo: `rulesOwned` mistura número e string. */
export function possuiPermissao(currentUser, permissao) {
  const owned = currentUser?.rulesOwned || [];
  const aceitas = Array.isArray(permissao) ? permissao : [permissao];
  return owned.some((p) => aceitas.some((req) => Number(p) === Number(req)));
}
